import { render, staticRenderFns } from "./calendar-event-name.vue?vue&type=template&id=77c645eb&scoped=true"
import script from "./calendar-event-name.vue?vue&type=script&lang=js"
export * from "./calendar-event-name.vue?vue&type=script&lang=js"
import style0 from "./calendar-event-name.vue?vue&type=style&index=0&id=77c645eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c645eb",
  null
  
)

export default component.exports